import { Timestamp } from 'firebase/firestore';
import type League from '@/models/league';
import type { leagueMember } from '@/models/user';
import type { LeaderboardMemberRow } from '@/views/LeaguePage/LeaderboardRow';

const ts = Timestamp.fromDate(new Date('2026-06-01'));

function member(
  partial: Pick<leagueMember, 'name' | 'currentRank' | 'prevRank' | 'currentScore' | 'prevScore'> &
    Partial<leagueMember>,
  uid: string,
): leagueMember {
  return {
    name: partial.name,
    currentRank: partial.currentRank,
    prevRank: partial.prevRank,
    currentScore: partial.currentScore,
    prevScore: partial.prevScore ?? partial.currentScore,
    userID: partial.userID ?? uid,
    joinedLeague: partial.joinedLeague ?? ts,
    rankLastUpdated: partial.rankLastUpdated ?? ts,
    guessError: partial.guessError,
    latecomer: partial.latecomer,
    spectator: partial.spectator,
    hasList: partial.hasList ?? !(partial.spectator ?? false),
  };
}

function league(name: string): League {
  return {
    name,
    adminUID: 'home-demo-admin',
    authCode: 'DEMO',
    memberCount: 1,
    ranksLastUpdated: ts,
  };
}

/** Global leaderboard preview (names unchanged from marketing copy). */
export const HOME_GLOBAL_LEADERBOARD_ROWS: LeaderboardMemberRow[] = [
  {
    memberUid: 'james',
    member: member({ name: 'James', currentRank: 1, prevRank: 2, currentScore: 160, prevScore: 155 }, 'james'),
    displayRank: 1,
    isYou: false,
    isLeagueAdmin: false,
    showRankChange: true,
    listPosition: 0,
    isAdminViewer: false,
    canKick: false,
    tournamentStarted: true,
  },
  {
    memberUid: 'amanda',
    member: member({ name: 'Amanda', currentRank: 2, prevRank: 4, currentScore: 149, prevScore: 140 }, 'amanda'),
    displayRank: 2,
    isYou: false,
    isLeagueAdmin: false,
    showRankChange: true,
    listPosition: 1,
    isAdminViewer: false,
    canKick: false,
    tournamentStarted: true,
  },
  {
    memberUid: 'william',
    member: member({ name: 'William', currentRank: 3, prevRank: 3, currentScore: 144, prevScore: 142 }, 'william'),
    displayRank: 3,
    isYou: false,
    isLeagueAdmin: false,
    showRankChange: true,
    listPosition: 2,
    isAdminViewer: false,
    canKick: false,
    tournamentStarted: true,
  },
  {
    memberUid: 'mia',
    member: member({ name: 'Mia', currentRank: 4, prevRank: 2, currentScore: 121, prevScore: 128 }, 'mia'),
    displayRank: 4,
    isYou: false,
    isLeagueAdmin: false,
    showRankChange: true,
    listPosition: 3,
    isAdminViewer: false,
    canKick: false,
    tournamentStarted: true,
  },
];

export const HOME_LEAGUES_LIST_DEMO: { league: League; memberData: leagueMember; isAdmin?: boolean }[] = [
  {
    league: league('Global League'),
    memberData: member({ name: 'You', currentRank: 8218, prevRank: 9100, currentScore: 89, prevScore: 72 }, 'home-demo-you'),
  },
  {
    league: league('The Smiths League'),
    memberData: member({ name: 'You', currentRank: 2, prevRank: 5, currentScore: 127, prevScore: 118 }, 'home-demo-you'),
  },
  {
    league: league('Office League'),
    memberData: member({ name: 'You', currentRank: 3, prevRank: 1, currentScore: 127, prevScore: 130 }, 'home-demo-you'),
    isAdmin: true,
  },
  {
    league: league('Michaels League'),
    memberData: member({ name: 'You', currentRank: 4, prevRank: 4, currentScore: 98, prevScore: 95 }, 'home-demo-you'),
  },
];
